import { Auth, connectAuthEmulator, getAuth } from "firebase/auth";
import serviceConfig from "../../serviceConfig.js";
import { getDefaultFirebaseApp } from "./firebase.js";

let _auth: Auth | null = null;
let _emulatorConnected = false;

export function getFirebaseAuth(): Auth {
  if (!_auth) {
    _auth = getAuth(getDefaultFirebaseApp());
    
    // Connect to emulator in dev mode
    const isDev = typeof __DEV__ !== "undefined" ? __DEV__ : process.env.NODE_ENV === "development";
    if (isDev && serviceConfig.shouldUseLocalBackend && !_emulatorConnected) {
      try {
        connectAuthEmulator(_auth, "http://127.0.0.1:9099", { disableWarnings: true });
        _emulatorConnected = true;
        console.log("Connected to Firebase Auth emulator");
      } catch (e) {
        console.warn("Failed to connect to Auth emulator:", e);
      }
    }
  }
  return _auth;
}
